<div class="pricePoint" [ngStyle]="{ minHeight: flightDetails.greenerChoice ? '110px' : '80px' }">
  <div class="pricePoint-wrapper">
    @if (ShowSelectButton && !flightDiscriptor?.unavailable) {
      <div
        class="pricePill"
        [ngClass]="{
          'dissable-cabin-class':
            !flightDiscriptor.selected &&
            direction === FlightDirectionEnum.Outbound &&
            dissableCabinClass
        }"
        (click)="selectFlight(flightDiscriptor)"
        (keydown.enter)="selectFlight(flightDiscriptor)"
        tabindex="0"
        [attr.aria-label]="ticketAriaLabel"
        role="button"
      >
        @if (flightDiscriptor) {
          <div class="price">
            @if (
              !flightDiscriptor.selected ||
              (direction !== FlightDirectionEnum.Outbound &&
                direction !== FlightDirectionEnum.DualSingleOutbound)
            ) {
              <span
                >{{
                  flightDiscriptor.total.price
                    | currency: flightDiscriptor.total.currency : 'symbol' : '0.0-0'
                }}
              </span>
            }
            <app-warning-tags
              [iconId]="flightDiscriptor.uid"
              [ticket]="flightDiscriptor"
            ></app-warning-tags>
            @if (
              flightDiscriptor.selected &&
              (direction === FlightDirectionEnum.Outbound ||
                direction === FlightDirectionEnum.DualSingleOutbound)
            ) {
              <span i18n="@@flightClassDeselect">Deselect</span>
            }
            @if (showDump) {
              <button (click)="alwaysLog(flightDiscriptor)" i18n="@@dump">Dump</button>
            }
          </div>
        }
      </div>
    } @else {
      <div class="pricePill pill_disabled" aria-disabled="true">
        <br />
        <div class="price" tabindex="-1">
          @if (!selected) {
            <span
              >{{
                flightDiscriptor.total.price
                  | currency: flightDiscriptor.total.currency : 'symbol' : '0.0-0'
              }}
            </span>
          }
          <app-warning-tags
            [iconId]="flightDiscriptor.uid"
            [ticket]="flightDiscriptor"
          ></app-warning-tags>
        </div>
      </div>
    }
    @if (getSeatsRemaining(flightDiscriptor, direction) < 9) {
      <div class="seats_remaining">
        @if (getSeatsRemaining(flightDiscriptor, direction) > 1) {
          <div>
            {{ getSeatsRemaining(flightDiscriptor, direction) }}
            <span i18n="@@flightSeatsLeft">Seats left</span>
          </div>
        } @else {
          {{ getSeatsRemaining(flightDiscriptor, direction) }}
          <span i18n="@@flightSeatLeft">Seat left</span>
        }
      </div>
    }
    @if (showSpecialFares(flightDiscriptor, direction)) {
      <div class="special-fares-container">
        <app-special-fare-icon
          [flight]="flightDiscriptor"
          [direction]="direction"
        ></app-special-fare-icon>
      </div>
    }
  </div>

  @if (flightDiscriptor.co2PerPassenger) {
    <div class="c02-wrapper">
      {{ flightDiscriptor.co2PerPassenger }}<span i18n="@flight_kg">kg</span>&nbsp;<span
        i18n="@flight_leg_co2"
        >CO</span
      ><sub i18n="@flight_leg_2">2</sub>&nbsp;<span i18n="@flight_pp">pp</span>
    </div>
  }
</div>
